/**
 *头部
 *@prop {number, string} activeIndex 需要激活点导航索引
 *@prop {number, string} mid 专业id
 */
Vue.component('page-header', {
    template:
        '<div class="page-header">\n' +
        '        <div class="container clearfix">\n' +
        '            <div class="logo fl">\n' +
        '                <a :href="mid == 96 ? \'https://www.zkjan.com/pages/cmc/list.html\' : \'https://www.zkjan.com\'">\n' +
        '                	<img src="images/header-logo.png?2102231610" alt="中科建安- 中级注册安全工程师|初级安全工程师|一级建造师|一级消防工程师|一级造价工程师|监理工程师|中级经济师|中级会计师|注安专业免费公开课|免费课件下载|在线题库|在线真题模拟|答题宝小程序|中科建安- 职业安全教育网">\n' +
        '                </a>\n' +
        '            </div>\n' +
        '            <div class="btns-wrap fr" v-if="!loginFlag">\n' +
        '                <span class="text-btn" @click="goLogin(1)">登录</span>\n' +
        '                <span class="division">|</span>\n' +
        '                <span class="text-btn" @click="goLogin(2)">注册</span>\n' +
        '            </div>\n' +
        '            <div class="info" v-if="loginFlag">\n' +
        '                <div class="user clearfix">\n' +
        '                    <a :href="mid == 96 ? \'pages/cmc/user.html\' : \'pages/user/class.html\'">\n' +
        '                    	<div class="photo-wrap fl">\n' +
        '                        	<img :src="user.logo || \'images/photo-default.png?2102231609\'" alt="">\n' +
        '                    	</div>\n' +
        '                    	<div class="name fl" :title="user.nickname ? user.nickname : user.phone">{{user.nickname ? user.nickname : user.phone}}</div>\n' +
        '                    </a>\n' +
        '                    <span class="iconfont icon-xia"></span>\n' +
        '                </div>\n' +
        '                <ul class="list">\n' +
        '                    <a :href="mid == 96 ? \'pages/cmc/user.html\' : \'pages/user/class.html\'">\n' +
        '                        <li class="item">学习中心</li>\n' +
        '                    </a>\n' +
        '                    <a :href="authSetUrl" target="_blank">\n' +
        '                        <li class="item">账户设置</li>\n' +
        '                    </a>\n' +
        '                    <li class="item" @click="logout">退出登录</li>\n' +
        '                </ul>\n' +
        '            </div>\n' +
        '            <a :href="mid == 96 ? \'pages/cmc/user.html\' : \'pages/user/class.html\'">\n' +
        '                <div class="fr btn solid red">学习中心</div>\n' +
        '            </a>\n' +
        '        </div>\n' +
        '    </div>',
    props: {
        activeIndex: [Number, String],
        mid: {
            type: [Number, String],
            default: 11
        }
    },
    data() {
        return {
            authSetUrl:authSetUrl,
            loginFlag: null,
            user: {}
        }
    },
    methods: {
        logout() {
            axios.post(baseURL + 'loginout')
                .then(res => {
                    if (res.code == 200) {
                        localStorage.psw = '';
                        location.reload();
                    }
                })
                .catch(err => console.log(err));
        },
    },
    created() {
        this.checkLogin(user => {
            if (user) {
                this.loginFlag = true;
                this.user = user.user;
            } else {
                this.loginFlag = false;
            }
            this.$emit('header-login', this.user);
        });
    }
});

/**
 *专业头部
 *@prop {number, string} activeIndex 需要激活点导航索引
 *@prop {number, string} mid 专业id
 */
Vue.component('major-header', {
    template:
        '<div class="page-header">\n' +
        '        <div class="container clearfix">\n' +
        '            <div class="logo fl">\n' +
        '                <a href="https://www.zkjan.com" target="_blank">\n' +
        '                	<img src="images/header-logo.png?2102231610" alt="">\n' +
        '                </a>\n' +
        '            </div>\n' +
        '            <ul class="nav fl clearfix">\n' +
        '                <li class="nav-item fl" v-for="(item, index) in navList" :key="index" :class="{active: index == activeIndex}" @click="changeNav(item, index)">{{item.text}}</li>\n' +
        '            </ul>\n' +
        '            <div class="btns-wrap fr" v-if="!loginFlag">\n' +
        '                <span class="text-btn" @click="goLogin(1)">登录</span>\n' +
        '                <span class="division">|</span>\n' +
        '                <span class="text-btn" @click="goLogin(2)">注册</span>\n' +
        '            </div>\n' +
        '            <div class="info" v-if="loginFlag">\n' +
        '                <div class="user clearfix">\n' +
        '                    <a href="pages/user/class.html">\n' +
        '                    	<div class="photo-wrap fl">\n' +
        '                        	<img :src="user.logo || \'images/photo-default.png?2102231609\'" alt="">\n' +
        '                    	</div>\n' +
        '                    	<div class="name fl" :title="user.nickname ? user.nickname : user.phone">{{user.nickname ? user.nickname : user.phone}}</div>\n' +
        '                    </a>\n' +
        '                    <span class="iconfont icon-xia"></span>\n' +
        '                </div>\n' +
        '                <ul class="list">\n' +
        '                    <a href="pages/user/class.html">\n' +
        '                        <li class="item">学习中心</li>\n' +
        '                    </a>\n' +
        '                    <li class="item" @click="logout">退出登录</li>\n' +
        '                </ul>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>',
    props: {
        activeIndex: [Number, String],
        mid: {
            type: [Number, String],
            default: 11
        }
    },
    data() {
        return {
            loginFlag: null,
            navList: [
                {
                    text: '首页',
                    link: 'pages/major/home.html?mid='
                },
                {
                    text: '',
                    link: 'pages/class/list.html?mid='
                },
                {
                    text: '题库',
                    link: 'pages/test/list.html?mid='
                },
                {
                    text: '备考资料',
                    link: 'pages/data/list.html?mid='
                },
                {
                    text: '考试指南',
                    link: 'pages/guide/detail.html?mid='
                },
                {
                    text: '新闻资讯',
                    link: 'pages/news/list.html?mid='
                },
                {
                    text: '学习中心',
                    link: 'pages/user/class.html?mid='
                },
            ],
            carCount: 0,
            user: {}
        }
    },
    watch: {
        mid: function(newVal) {
            switch (newVal - 0) {
                case 1:
                    this.navList[0].text = '一级建造师';
                    break;
                case 2:
                    this.navList[0].text = '二级建造师';
                    break;
                case 10:
                    this.navList[0].text = '监理工程师';
                    break;
                case 11:
                    this.navList[0].text = '中级安全工程师';
                    break;
                case 71:
                    this.navList[0].text = '初级安全工程师';
                    break;
                case 13:
                    this.navList[0].text = '一级消防工程师';
                    break;
                case 91:
                    this.navList[0].text = '二级消防工程师';
                    break;
                case 64:
                    this.navList[0].text = '初级经济师';
                    break;
                case 65:
                    this.navList[0].text = '中级经济师';
                    break;
                case 67:
                    this.navList[0].text = '一级造价工程师';
                    break;
                case 70:
                    this.navList[0].text = '二级造价工程师';
                    break;
                case 68:
                    this.navList[0].text = '初级会计师';
                    break;
                case 69:
                    this.navList[0].text = '中级会计师';
                    break;
                default:
                    break;
            }
            this.$emit('name', this.navList[0].text);
            if (newVal != 11 && newVal != 71 && newVal != 13 && newVal != 91) {
                this.navList[0].link = 'pages/major/home1.html?mid='
            }
        }
    },
    methods: {
        changeNav(nav, index) {
            if (index == this.activeIndex) return
            switch (index) {
                case 1: // 选班报名
                    if (this.mid == 68 || this.mid == 69) return
                    break;
                case 3: // 备考资料
                case 5: // 新闻资讯
                    if (this.mid != 11 && this.mid != 71 && this.mid != 13 && this.mid != 91) return
                    break;
                case 4: // 考试指南
                    if (this.mid != 11 && this.mid != 71 && this.mid != 13 && this.mid != 2) return
                    break;
                default:
                    break;
            }
            window.open(nav.link + this.mid);
        },
        logout() {
            axios.post(baseURL + 'loginout')
                .then(res => {
                    if (res.code == 200) {
                        localStorage.psw = '';
                        location.reload();
                    }
                })
                .catch(err => console.log(err));
        },
    },
    created() {
        this.checkLogin(user => {
            if (user) {
                this.loginFlag = true;
                this.carCount = user.carCount;
                this.user = user.user;
            } else {
                this.loginFlag = false;
            }
            this.$emit('header-login', this.user);
        });
    }
});

/**
 *专业头部
 *@prop {number, string} activeId 需要激活点导航索引
 *@prop {number, string} mid 专业id
 */
Vue.component('home-header', {
    template:
        '<div class="home-header" :class="{fixed: fixedFlag}">\n' +
        '    <div class="top">\n' +
        '        <div class="container clearfix">\n' +
        '            <div class="fl left">\n' +
        '                <span style="margin-right: 12px;" v-if="loginFlag">{{user.nickname ? user.nickname : user.phone}}</span>\n' +
        '                <span class="text-btn" v-if="loginFlag" @click="logout">退出登录</span>\n' +
        '                <div v-if="!loginFlag"><span class="text-btn" @click="goLogin()">登录</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span class="text-btn" @click="goLogin(2)">注册</span></div>\n' +
        '            </div>\n' +
        '            <div class="fr right">\n' +
        '                <a class="text-btn" href="">首页</a>\n' +
        '                <a class="text-btn" href="pages/about/about.html" target="_blank">关于我们</a>\n' +
        '                <a class="text-btn" href="pages/help/feedback.html" target="_blank">意见反馈</a>\n' +
        '                <span title="热线电话"><span class="iconfont icondianhua"></span>400-0366-886</span>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '    <div class="middle">\n' +
        '        <div class="container clearfix">\n' +
        '            <a href="https://www.zkjan.com">\n' +
        '                <div class="fl logo">\n' +
        '                    <img src="images/header-logo.png" alt="">\n' +
        '                </div>\n' +
        '            </a>\n' +
        '            <div class="fr right clearfix">\n' +
        '                <a href="pages/user/class.html" target="_blank">\n' +
        '                    <div class="fl btn solid red">学习中心</div>\n' +
        '                </a>\n' +
        '                <div class="fl btn border" @click="goLogin()" v-if="!loginFlag">登录</div>\n' +
        '                <a href="pages/user/info.html" target="_blank" v-if="loginFlag">\n' +
        '                    <div class="fl photo-wrap" title="个人资料">\n' +
        '                        <img :src="user.logo || \'images/photo-default.png?2102231609\'">\n' +
        '                    </div>\n' +
        '                </a>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '    <div class="bottom">\n' +
        '        <div class="container clearfix">\n' +
        '            <div class="fl major-select">\n' +
        '                <div class="toggle" @click="goMajorHome">\n' +
        '                    <div class="label"><span></span></div>\n' +
        '                    {{mName}}\n' +
        '                </div>\n' +
        '                <div class="menu">\n' +
        '                    <ul class="majors clearfix">\n' +
        '                        <li class="fl group" v-for="item in majors" :key="item.gt">\n' +
        '                            <div class="group-title">{{item.gt}}</div>\n' +
        '                            <ul class="major-list">\n' +
        '                                <li class="major text-btn" v-for="mItem in item.list" :key="mItem.mid" :class="{hot: mItem.isHot}" @click="selectMajor(mItem.mid)">{{mItem.mt}}</li>\n' +
        '                            </ul>\n' +
        '                        </li>\n' +
        '                    </ul>\n' +
        '                </div>\n' +
        '            </div>\n' +
        '            <div class="fr nav-list">\n' +
        '                <div class="fl item" v-for="item in navList" :key="item.id" :class="{active: item.isActive}" @click="changeNav(item)">{{item.text}}</div>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '</div>',
    props: {
        activeId: [Number, String],
        mid: [Number, String]
    },
    data() {
        return {
            majors: JSON.parse(localStorage.majors),
            loginFlag: null,
            navList: [
                {
                    id: 1,
                    text: '课程',
                    link: 'pages/class/list.html?mid=',
                    isActive: false
                },
                {
                    id: 2,
                    text: '直播',
                    link: 'pages/live/list.html?mid=',
                    isActive: false
                },
                {
                    id: 3,
                    text: '题库',
                    link: 'pages/test/list.html?mid=',
                    isActive: false
                },
                {
                    id: 4,
                    text: '报考指南',
                    link: 'pages/guide/detail.html?mid=',
                    isActive: false
                },
                {
                    id: 5,
                    text: '备考资料',
                    link: 'pages/data/list.html?mid=',
                    isActive: false
                },
                {
                    id: 6,
                    text: '考试动态',
                    link: 'shtml/news/',
                    isActive: false
                },
                {
                    id: 7,
                    text: '师资荣誉',
                    link: 'pages/teacher/list.html?mid=',
                    isActive: false
                },
            ],
            user: {},
            mName: '',
            fixedFlag: false
        }
    },
    watch: {
        mid: function (newVal) {
            this.majors.forEach(item => {
                item.list.forEach(mItem => {
                    if (mItem.mid == newVal) {
                        this.mName = mItem.mt;
                        this.$emit('name', this.mName);
                    }
                })
            })
        }
    },
    methods: {
        logout: function() {
            axios.post(baseURL + 'loginout')
                .then(res => {
                    if (res.code == 200) {
                        localStorage.psw = '';
                        location.reload();
                    }
                })
                .catch(err => console.log(err));
        },
        goMajorHome: function () {
            location.href = 'pages/major/' + this.mid + '.html?mid=' + this.mid;
        },
        changeNav: function(nav) {
            if (nav.id == 6) {
                window.open(nav.link + this.mid + '.html')
            } else {
                window.open(nav.link + this.mid)
            }
        },
        selectMajor: function(id) {
            switch (id) {
                case 11:
                case 71:
                case 13:
                case 91:
                    window.open('pages/major/' + id + '.html?mid=' + id);
                    break;
                case 1:
                    window.open('https://www.zgjan.com/jzs1.html');
                    break;
                case 2:
                    window.open('https://www.zgjan.com/jzs2.html');
                    break;
                case 67:
                    window.open('https://www.zgjan.com/yjzj.html');
                    break;
                case 70:
                    window.open('https://www.zgjan.com/ejzj.html');
                    break;
                case 10:
                    window.open('https://www.zgjan.com/jianli.html');
                    break;
                case 65:
                    window.open('https://www.zgjan.com/zjjj.html');
                    break;
                case 64:
                    window.open('https://www.zgjan.com/cjjj.html');
                    break;
                case 69:
                    window.open('https://www.zgjan.com/zjkj.html');
                    break;
                case 68:
                    window.open('https://www.zgjan.com/cjkj.html');
                    break;
                default:
                    break;
            }
        }
    },
    created: function() {
        this.checkLogin(user => {
            if (user) {
                this.loginFlag = true;
                this.user = user.user;
            }
            this.$emit('header-login', this.user);
        });
    },
    mounted: function () {
        this.navList.forEach(item => {
            item.isActive = item.id == this.activeId;
        });
        window.addEventListener('scroll', () => {
            let b = document.documentElement.scrollTop ? document.documentElement : document.body;
            this.fixedFlag = b.scrollTop > 124;
            this.$emit('fixed', this.fixedFlag)
        });
    }
});

/**
 *学习中心头部
 */
Vue.component('user-header', {
    template:
        '<div class="page-header user-header">\n' +
        '        <div class="logo fl" style="margin-left: 50px;">\n' +
        '            <a href="https://www.zkjan.com" target="_blank">\n' +
        '                	<img src="images/header-logo.png?2102231610" alt="">\n' +
        '            </a>\n' +
        '        </div>\n' +
        '    <div class="container clearfix">\n' +
        '        <div class="fl major-select">\n' +
        '            <div class="toggle">\n' +
        '                <span class="label">专业：</span>\n' +
        '                <span class="title">{{user.last_major_name}}</span>\n' +
        '            </div>\n' +
        '            <div class="menu">\n' +
        '                <ul class="majors clearfix">\n' +
        '                    <li class="fl group" v-for="item in majors" :key="item.gt">\n' +
        '                        <div class="group-title">{{item.gt}}</div>\n' +
        '                        <ul class="major-list">\n' +
        '                            <li class="major text-btn" v-for="mItem in item.list" :key="mItem.mid" :class="{hot: mItem.isHot}" @click="selectMajor(mItem.mid)">{{mItem.mt}}</li>\n' +
        '                        </ul>\n' +
        '                    </li>\n' +
        '                </ul>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '        <div class="info" style="right: 50px;">\n' +
        '            <div class="user clearfix">\n' +
        '                 <div class="photo-wrap fl">\n' +
        '                     <img :src="user.logo || \'images/photo-default.png?2102231609\'" alt="">\n' +
        '                 </div>\n' +
        '                 <div class="name fl" :title="user.nickname ? user.nickname : user.phone">{{user.nickname ? user.nickname : user.phone}}</div>\n' +
        '                <span class="iconfont icon-xia"></span>\n' +
        '            </div>\n' +
        '            <ul class="list">\n' +
        '                <a href="pages/user/class.html">\n' +
        '                    <li class="item">学习中心</li>\n' +
        '                </a>\n' +
        '                <li class="item" @click="logout">退出登录</li>\n' +
        '            </ul>\n' +
        '        </div>\n' +
        '    <div v-if="firstFlag" class="major-first">\n' +
        '        <div class="box">\n' +
        '            <div class="box-header">请选择报考专业</div>\n' +
        '            <div class="box-content">\n' +
        '                <ul class="majors">\n' +
        '                    <li class="group" v-for="(item, index) in majors" :key="item.gt">\n' +
        '                        <div class="group-title">\n' +
        '                            <div class="img">\n' +
        '                                <img :src="\'images/major-type\' + index + \'.png\'" alt="">\n' +
        '                            </div>\n' +
        '                            <p class="text">{{item.tt}}</p>\n' +
        '                        </div>\n' +
        '                        <ul class="major-list">\n' +
        '                            <li class="major" v-for="mItem in item.list" :key="mItem.mid" @click="selectMajor(mItem.mid)">{{mItem.mt}}</li>\n' +
        '                        </ul>\n' +
        '                    </li>\n' +
        '                </ul>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '</div>',
    data() {
        return {
            majors: JSON.parse(localStorage.majors),
            loginFlag: null,
            carCount: 0,
            user: {},
            firstFlag: false,
            currentMajor: {
                mid: 0,
                mt: ''
            }
        }
    },
    methods: {
        changeNav: function(nav) {
            window.open(nav.link)
        },
        selectMajor: function(id) {
            switch (id) {
                case 11:
                case 71:
                case 13:
                case 91:
                    axios.post(baseURL + 'upLastMajor?mid=' + id)
                        .then(res => {
                            if (res.code == 200) {
                                location.href = location.href.split('.html')[0] + '.html';
                            }
                        })
                        .catch(err => console.log(err));
                    break;
                case 1:
                    window.open('https://www.zgjan.com/jzs1.html');
                    break;
                case 2:
                    window.open('https://www.zgjan.com/jzs2.html');
                    break;
                case 67:
                    window.open('https://www.zgjan.com/yjzj.html');
                    break;
                case 70:
                    window.open('https://www.zgjan.com/ejzj.html');
                    break;
                case 10:
                    window.open('https://www.zgjan.com/jianli.html');
                    break;
                case 65:
                    window.open('https://www.zgjan.com/zjjj.html');
                    break;
                case 64:
                    window.open('https://www.zgjan.com/cjjj.html');
                    break;
                case 69:
                    window.open('https://www.zgjan.com/zjkj.html');
                    break;
                case 68:
                    window.open('https://www.zgjan.com/cjkj.html');
                    break;
                default:
                    break;
            }
        },
        logout: function() {
            axios.post(baseURL + 'loginout')
                .then(res => {
                    if (res.code == 200) {
                        localStorage.psw = '';
                        location.reload();
                    }
                })
                .catch(err => console.log(err));
        },
    },
    created: function() {
        this.checkLogin(user => {
            if (user) {
                this.loginFlag = true;
                this.carCount = user.carCount;
                this.user = user.user;
                if (this.user.last_major_id === 0) {
                    this.firstFlag = true;
                } else {
                    this.majors.forEach(gItem => {
                        gItem.list.forEach(item => {
                            if (item.mid == this.user.last_major_id) {
                                this.user.last_major_name = item.mt
                            }
                        })
                    })
                }
                this.$emit('header-login', this.user);
            } else {
                this.goLogin(1);
            }
        });
    }
});

/**
 *页脚
 *@prop {boolean} light 是否浅色页脚
 *@prop {number, string} mid 专业id
 */
Vue.component('page-footer', {
    template:'<footer class="index-footer">\n'+
    '    <div class="footer-container">\n'+
    '      <div class="top-type">\n'+
    '        <div class="ul-type">关于我们</div>\n'+
    '        <div class="ul-type">服务中心</div>\n'+
    '        <div class="ul-type">用户中心</div>\n'+
    '        <div class="ul-type">产品中心</div>\n'+
    '        <div class="code-type"></div>\n'+
    '        <div class="consulting-type">咨询热线</div>\n'+
    '      </div>\n'+
    '      <div class="bottom-content">\n'+
    '        <div class="ul-type">\n'+
    '          <div class="list">\n'+
    '            <a class="item" href="pages/about/about.html" target="_blank">公司简介</a>\n'+
    '            <a class="item" href="pages/news/bdlist.html?type=22" target="_blank">媒体报道</a>\n'+
    '            <a class="item" href="pages/about/about.html?type=5" target="_blank">联系我们</a>\n'+
    '            <a class="item" href="pages/about/about.html?type=6" target="_blank">公司账户</a>\n'+
    '          </div>\n'+
    '        </div>\n'+
    '        <div class="ul-type">\n'+
    '          <div class="list">\n'+
    '            <a class="item" href="pages/user/class.html" target="_blank">学习中心</a>\n'+
    '            <a class="item" href="pages/help/feedback.html" target="_blank">投诉建议</a>\n'+
    '            <a class="item" href="pages/help/agreement.html" target="_blank">郑重声明</a>\n'+
    '          </div>\n'+
    '        </div>\n'+
    '        <div class="ul-type">\n'+
    '          <div class="list">\n'+
    '            <a class="item" :href="registerHref" target="_blank">注册账号</a>\n'+
    '            <a class="item" target="_blank">注册协议</a>\n'+
    '            <a class="item" target="_blank">反馈纠错</a>\n'+
    '          </div>\n'+
    '        </div>\n'+
    '        <div class="ul-type">\n'+
    '          <div class="list">\n'+
    '            <a class="item" href="https://www.zkjan.com/pages/test/list.html?mid=11" target="_blank">题库</a>\n'+
    '            <a class="item" href="https://www.zkjan.com/pages/class/list.html?mid=11" target="_blank">课程</a>\n'+
    '            <a class="item" target="_blank">新媒体矩阵</a>\n'+
    '          </div>\n'+
    '        </div>\n'+
    '        <div class="code-type">\n'+
    '          <div class="code-list">\n'+
    '            <div class="box">\n'+
    '              <img class="img" src="./images/qrcode-xcx.png" alt="">\n'+
    '              <div class="desc">做题宝小程序</div>\n'+
    '            </div>\n'+
    '            <div class="box">\n'+
    '              <img class="img" src="./images/qrcode.jpg?2102231610" alt="">\n'+
    '              <div class="desc">中科建安公众号</div>\n'+
    '            </div>\n'+
    '          </div>\n'+
    '        </div>\n'+
    '        <div class="consulting-type">\n'+
    '          <div class="box">\n'+
    '            <div class="tel">400-0366-886</div>\n'+
    '            <a href="https://ykf-webchat.7moor.com/wapchat.html?accessId=6bd46320-c33b-11eb-b7b4-9b338f0b0f32&fromUrl=http://wx.zkjan.com&urlTitle=%E5%BE%AE%E4%BF%A1&language=ZHCN" target="_blank">\n'+
    '               <div class="consulting">在线咨询</div>\n'+
    '            </a>\n'+
    '          </div>\n'+
    '        </div>\n'+
    '      </div>\n'+
    '      <div class="copyright">\n'+
    '        <span>版权所有©2006-2023<a href="/" target="_self">中科建安（北京）安全技术服务有限公司（www.zkjan.com）</a></span>\n'+
    '        <span> All Rights Reserved</span>\n'+
    '        <span>ICP许可证：京ICP备2022020722</span>\n'+
'            <a href="https://beian.miit.gov.cn" target="_blank"><span>京ICP备2022020722号-2</span></a>\n'+
    '        <span>公司地址：北京市昌平区石坊院21号12层1207</span>\n'+
    '      </div>\n'+
    '    </div>\n'+
    '</footer>',
    data() {
        return {
            registerHref:''
        }
    },
    methods: {
    },
    created: function() {
        this.registerHref  = Vue.prototype.goLogin(2,true)
    }
});

/**
 *浮窗工具
 */
Vue.component('toolbar', {
    template:
        '<div class="toolbar" v-show="showFlag">\n' +
        '        <span class="iconfont icon-close close-btn" title="关闭" @click="showFlag = false"></span>\n' +
        '        <ul class="link-list">\n' +
        '            <li class="link-item" @click="openWin">报考条件</li>\n' +
        '            <li class="link-item" @click="openWin">考试政策</li>\n' +
        '            <li class="link-item" @click="openWin">考试流程</li>\n' +
        '            <li class="link-item" @click="openWin">考试时间</li>\n' +
        '            <li class="link-item" @click="openWin">考前准备</li>\n' +
        '            <li class="link-item" @click="openWin">考前提分</li>\n' +
        '            <li class="link-item">\n' +
        '                微信公众号\n' +
        '                <div class="qrcode">\n' +
        '                    <p class="text">扫描关注微信公众号</p>\n' +
        '                    <img src="images/qrcode.png?2102231610" alt="">\n' +
        '                </div>\n' +
        '            </li>\n' +
        '        </ul>\n' +
        '        <div class="top" title="返回顶部">\n' +
        '            <span class="iconfont icon-fanhuidingbu" @click="backTop"></span>\n' +
        '        </div>\n' +
        '    </div>',
    data() {
        return {
            showFlag: true
        }
    },
    methods: {
        openWin() {
            let shangqiaoBtn = document.querySelector('#nb_invite_ok');
            if (shangqiaoBtn) {
                shangqiaoBtn.click();
            }
        },
        backTop() {
            this.scrollTo(0);
        }
    }
});

/**
 *登录/注册
 *@prop {number, string} type 表单类型(1:登录, 2:注册)
 *@prop {number, string} fromWay 注册来源(7:aaa认证)
 *@prop {boolean} closed 是否可以关闭
 */
Vue.component('login-form', {
    template:
        '<div class="login-form" :class="[{register: type == 2 || type == 3}]">\n' +
        '    <span class="close-btn iconfont icon-guanbi" title="关闭" v-if="closed" @click="close"></span>\n' +
        '    <div class="form" v-if="type == 1">\n' +
        '        <div class="title clearfix">\n' +
        '            <p class="text fl active">扫码登录</p>\n' +
        '            <p class="text fl other" @click="changeType(4)">密码登录</p>\n' +
        '        </div>\n' +
        '        <div class="qrcode-wrap">\n' +
        '            <img class="qrcode" :src="qrcode" alt="">\n' +
        '            <div class="status-wrap" v-show="qrcodeStatus == 1">\n' +
        '                <img src="images/login-success.png" alt="">\n' +
        '                <p>登录成功</p>\n' +
        '            </div>\n' +
        '            <div class="status-wrap reload" v-show="qrcodeStatus == 2" @click="reloadQrcode">\n' +
        '                <img src="images/login-reload.png" alt="">\n' +
        '                <p>重新获取</p>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '        <div class="qrcode-text">扫码关注公众号完成登录</div>\n' +
        '    </div>\n' +
        '    <div class="form" v-if="type == 5">\n' +
        '        <div class="title clearfix" style="margin-bottom: 24px;">\n' +
        '            <p class="text">绑定手机号</p>\n' +
        '            <p class="sub" style="padding-top: 0;">为全面体验产品和服务，请您绑定手机号</p>\n' +
        '        </div>\n' +
        '        <div class="input-group solid no-icon">\n' +
        '            <input type="text" placeholder="手机号" v-model="registForm.phone" @keyup.enter="regist" @input="clearRegistErr(1)">\n' +
        '            <p class="err">{{registForm.phoneErr}}</p>\n' +
        '        </div>\n' +
        '        <div class="clearfix">\n' +
        '            <div class="input-group solid no-icon with-btn fl" style="width: 182px;">\n' +
        '                <input type="text" placeholder="图形验证" v-model="registForm.imgCode" @keyup.enter="regist" @input="clearRegistErr(2)">\n' +
        '                <p class="err">{{registForm.imgCodeErr}}</p>\n' +
        '            </div>\n' +
        '            <div class="img-validate fr">\n' +
        '                <img :src="imgCodeSrc" alt="" @click="num++" title="刷新验证码">\n' +
        '            </div>\n' +
        '        </div>\n' +
        '        <div class="clearfix">\n' +
        '            <div class="input-group solid no-icon with-btn">\n' +
        '                <input type="text" placeholder="验证码" v-model="registForm.msgCode" @keyup.enter="regist" @input="clearRegistErr(3)">\n' +
        '                <div class="input-btn" @click="getMsgCode">{{getMsgBtnText}}</div>\n' +
        '                <p class="err">{{registForm.msgCodeErr}}</p>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '        <div class="btn-wrap">\n' +
        '            <p class="form-err">{{registForm.formErr}}</p>\n' +
        '            <div class="submit-btn solid" @click="regist">绑定</div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '    <div class="form" v-if="type == 4">\n' +
        '        <div class="title clearfix">\n' +
        '            <p class="text fl other" @click="changeType(1)">扫码登录</p>\n' +
        '            <p class="text fl active">密码登录</p>\n' +
        '        </div>\n' +
        '        <div class="input-group solid no-icon" style="margin-top: 30px;">\n' +
        '            <input type="number" placeholder="手机号" v-model="loginForm.phone" @keyup.enter="login" @input="clearLoginErr(1)">\n' +
        '            <p class="err">{{loginForm.phoneErr}}</p>\n' +
        '        </div>\n' +
        '        <div class="input-group solid no-icon">\n' +
        '            <input :type="pswRead ? \'text\' : \'password\'" placeholder="密码" v-model="loginForm.psw" @keyup.enter="login" @input="clearLoginErr(2)">\n' +
        '            <span class="iconfont" :class="pswRead ? \'iconyanjing-01-01\' : \'iconbiyan-02-02\'" @click="pswRead = !pswRead"></span>\n' +
        '            <p class="err">{{loginForm.pswErr}}</p>\n' +
        '        </div>\n' +
        '        <div class="sub clearfix">\n' +
        '            <div class="fl clearfix" @click="loginForm.checked == 1 ? loginForm.checked = 0 : loginForm.checked = 1">\n' +
        '                <div class="duigou-wrap fl" :class="{active: loginForm.checked}">\n' +
        '                    <span class="iconfont icon-duigou"></span>\n' +
        '                </div>\n' +
        '                <p class="text fl">下次自动登录</p>\n' +
        '            </div>\n' +
        '            <p class="text fr" @click="changeType(3)">忘记密码?</p>\n' +
        '        </div>\n' +
        '        <div class="btn-wrap">\n' +
        '            <p class="form-err">{{loginForm.formErr}}</p>\n' +
        '            <div class="submit-btn solid" @click="login">登录</div>\n' +
        '        </div>\n' +
        '        <p class="text-btn" @click="changeType(2)">快速注册</p>\n' +
        '    </div>\n' +
        '    <div class="form" v-if="type == 2 || type == 3 && !successFlag">\n' +
        '        <div class="title clearfix" style="margin-bottom: 6px;" v-if="type == 2">\n' +
        '            <p class="text fl" style="margin-right: 16px;">注册</p>\n' +
        '            <p class="sub fl">已有账号，<span class="btn" @click="changeType(1)">立即登录</span></p>\n' +
        '        </div>\n' +
        '        <div class="title clearfix" style="margin-bottom: 18px;" v-if="type == 3">\n' +
        '            <p class="text">找回密码</p>\n' +
        '        </div>\n' +
        '        <div class="input-group solid no-icon">\n' +
        '            <input type="text" placeholder="手机号" v-model="registForm.phone" @keyup.enter="regist" @input="clearRegistErr(1)">\n' +
        '            <p class="err">{{registForm.phoneErr}}</p>\n' +
        '        </div>\n' +
        '        <div class="clearfix">\n' +
        '            <div class="input-group solid no-icon with-btn fl" style="width: 182px;">\n' +
        '                <input type="text" placeholder="图形验证" v-model="registForm.imgCode" @keyup.enter="regist" @input="clearRegistErr(2)">\n' +
        '                <p class="err">{{registForm.imgCodeErr}}</p>\n' +
        '            </div>\n' +
        '            <div class="img-validate fr">\n' +
        '                <img :src="imgCodeSrc" alt="" @click="num++" title="刷新验证码">\n' +
        '            </div>\n' +
        '        </div>\n' +
        '        <div class="clearfix">\n' +
        '            <div class="input-group solid no-icon with-btn">\n' +
        '                <input type="text" placeholder="验证码" v-model="registForm.msgCode" @keyup.enter="regist" @input="clearRegistErr(3)">\n' +
        '                <div class="input-btn" @click="getMsgCode">{{getMsgBtnText}}</div>\n' +
        '                <p class="err">{{registForm.msgCodeErr}}</p>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '        <div class="input-group solid no-icon">\n' +
        '            <input :type="pswRead ? \'text\' : \'password\'" placeholder="密码" v-model="registForm.psw" @keyup.enter="regist" @input="clearRegistErr(4)">\n' +
        '            <span class="iconfont" :class="pswRead ? \'iconyanjing-01-01\' : \'iconbiyan-02-02\'" @click="pswRead = !pswRead"></span>\n' +
        '            <p class="err">{{registForm.pswErr}}</p>\n' +
        '        </div>\n' +
        '        <div class="sub clearfix" v-if="type == 2">\n' +
        '            <div class="duigou-wrap fl active">\n' +
        '                <span class="iconfont icon-duigou"></span>\n' +
        '            </div>\n' +
        '            <p style="font-size: 14px;">同意<a class="text" href="pages/help/agreement.html" target="_blank">《中科建安注册协议》</a>&<a class="text" href="pages/help/agreement.html" target="_blank">《隐私协议》</a></p>\n' +
        '        </div>\n' +
        '        <div class="btn-wrap">\n' +
        '            <p class="form-err">{{registForm.formErr}}</p>\n' +
        '            <div class="submit-btn solid" v-if="type == 2" @click="regist">注册并登录</div>\n' +
        '            <div class="submit-btn solid" v-if="type == 3" @click="regist">提交</div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '    <div class="form" v-if="successFlag">\n' +
        '        <div class="title clearfix">\n' +
        '            <p class="text">找回密码</p>\n' +
        '        </div>\n' +
        '        <div class="success">\n' +
        '            <form-success text="新密码修改成功" :class="{show: true}"></form-success>\n' +
        '            <p class="count-down"><span class="number">{{countDown}}</span> 秒后跳转至首页</p>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '</div>',
    props: {
        formType: {
            type: [Number, String],
            default: 1,
        },
        closed: Boolean,
        fromWay: [Number, String]
    },
    data() {
        return {
            pswRead: false,
            majorShowFlag: false,
            majorErr: '',
            majorName: '请选择专业',
            majorId: null,
            majorList: [],
            loadingFlag: false,
            type: this.formType,
            num: 0,
            // 是否允许获取验证码
            isAllowGetMsgCode: true,
            // 短信验证码倒计时
            count: 60,
            getMsgBtnText: '获取验证码',
            // 登录表单
            loginForm: {
                phone: '',
                phoneErr: '',
                psw: '',
                pswErr: '',
                checked: 1,
                formErr: ''
            },
            // 注册表单
            registForm: {
                phone: '',
                phoneErr: '',
                imgCode: '',
                imgCodeErr: '',
                msgCode: '',
                msgCodeErr: '',
                psw: '',
                pswErr: '',
                rePsw: '',
                rePswErr: '',
                formErr: ''
            },
            successFlag: false,
            countDown: 3,
            qrcode: '',
            scene: '',
            qrcodeTimer: null,
            qrcodeStatus: 0,
        }
    },
    computed: {
        imgCodeSrc() {
            return base + 'kstk-api/userlogin/validateCode?' + this.num;
        }
    },
    methods: {
        getMajorList() {
            axios.post(baseURL + 'getFmajor')
                .then(res => {
                    if (res.code == 200) {
                        this.majorList = res.list;
                    }
                })
                .catch(err => console.log(err));
        },
        selectMajor(major) {
            this.majorName = major.major_name;
            this.majorId = major.id;
            this.majorErr = '';
            this.majorShowFlag = false;
        },
        // 切换表单类型
        changeType(type) {
            if (this.qrcodeTimer) {
                clearInterval(this.qrcodeTimer)
            }
            this.$emit('change-type', type)
        },
        // 关闭
        close() {
            if (this.qrcodeTimer) {
                clearInterval(this.qrcodeTimer)
            }
            this.$emit('close');
        },
        getQrcode() {
            axios.get(base + 'kstk-api/scan/createQrCode?' + this.num)
                .then(res => {
                    if (res.code == 200) {
                        this.qrcode = res.ticket;
                        this.qrcodeTimer = setInterval(this.checkQrcode, 1000 * 1.5)
                        setTimeout(() => {
                            clearInterval(this.qrcodeTimer)
                            this.qrcodeStatus = 2;
                        }, 1000 * 80)
                    } else {
                        this.qrcodeStatus = 0;
                    }
                })
                .catch(err => console.log(err));
        },
        checkQrcode() {
            axios.get(base + 'kstk-api/scan/checkScan')
                .then(res => {
                    if (res.code == 200) {
                        this.qrcodeStatus = 1;
                        clearInterval(this.qrcodeTimer)
                        setTimeout(() => {
                            this.$emit('login-success');
                        }, 1000)
                    }
                    if (res.code == -4) {
                        this.changeType(5)
                    }
                })
                .catch(err => console.log(err));
        },
        reloadQrcode() {
            this.qrcodeStatus = 0;
            this.num ++;

            this.getQrcode();
        },
        // 清除错误提示
        clearLoginErr(type) {
            switch (type) {
                case 1:
                    this.loginForm.phoneErr = '';
                    break;
                case 2:
                    this.loginForm.pswErr = '';
                    break;
                default:
                    break;
            }
            this.loginForm.formErr = '';
        },
        clearRegistErr(type) {
            switch (type) {
                case 1:
                    this.registForm.phoneErr = '';
                    break;
                case 2:
                    this.registForm.imgCodeErr = '';
                    break;
                case 3:
                    this.registForm.msgCodeErr = '';
                    break;
                case 4:
                    this.registForm.pswErr = '';
                    break;
                case 5:
                    this.registForm.rePswErr = '';
                    break;
                default:
                    break;
            }
            this.registForm.formErr = '';
        },
        // 登录
        login() {
            if (this.loadingFlag) {
                return;
            }
            // 手机号验证
            if (!this.isPhoneNumber(this.loginForm.phone)) {
                this.loginForm.phoneErr = '请输入正确的手机号码!';
                return;
            }
            // 密码
            let psw = this.loginForm.psw.trim();
            if (psw.length < 4 || psw.length > 18) {
                this.loginForm.pswErr = '请输入4-18位（数字，字母，下划线）的密码!';
                return;
            }
            this.loadingFlag = true;
            axios.post(baseURL + 'login?ph=' + this.loginForm.phone + '&pw=' + this.loginForm.psw + '&checked=' + this.loginForm.checked)
                .then(res => {
                    this.loadingFlag = false;
                    if (res.code == 200) {
                        localStorage.phone = this.loginForm.phone;
                        if (this.loginForm.checked) {
                            localStorage.psw = this.loginForm.psw;
                        } else {
                            localStorage.psw = '';
                        }
                        this.$emit('login-success');
                    } else {
                        this.loginForm.formErr = res.msg;
                    }
                })
                .catch(err => console.log(err));
        },
        // 获取短信验证码
        getMsgCode() {
            if (this.loadingFlag || !this.isAllowGetMsgCode) {
                return;
            }
            this.clearRegistErr(3);

            if (!this.isPhoneNumber(this.registForm.phone)) {
                this.registForm.phoneErr = '请输入正确的手机号码!';
                return;
            }

            if (this.registForm.imgCode.trim() == '') {
                this.registForm.imgCodeErr = '请输入图片验证码!';
                return;
            }

            let reg = '';
            if (this.type == 3) {
                reg = '&reg=1';
            }

            let api = base + 'kstk-api/userlogin/getCode'
            if (this.type == 5) {
                api = base + 'kstk-api/userlogin/getsacnCode'
            }

            this.loadingFlag = true;
            axios.post(api + '?ph=' + this.registForm.phone + '&vcode=' + this.registForm.imgCode + reg)
                .then(res => {
                    this.loadingFlag = false;
                    if (res.code == 200) {
                        this.isAllowGetMsgCode = false;
                        this.getMsgBtnText = '已发送' + this.count;
                        // 倒计时60秒
                        let timer = setInterval(() => {
                            if (this.count > 0) {
                                this.count --;
                                this.getMsgBtnText = '已发送' + this.count;
                            } else {
                                this.getMsgBtnText = '重新获取';
                                this.isAllowGetMsgCode = true;
                                clearInterval(timer);
                            }
                        }, 1000);
                    } else {
                        res.msg.includes('手机') ? this.registForm.phoneErr = res.msg : this.registForm.imgCodeErr = res.msg;
                        this.isAllowGetMsgCode = true;
                    }
                })
                .catch(err => console.log(err));
        },
        // 注册/找回密码
        regist() {
            if (this.loadingFlag) {
                return;
            }
            // 手机号验证
            if (!this.isPhoneNumber(this.registForm.phone)) {
                this.registForm.phoneErr = '请输入正确的手机号码!';
                return;
            }
            // 短信验证
            if (this.registForm.msgCode.trim() == '') {
                this.registForm.msgCodeErr = '请输入短信验证码!';
                return;
            }
            // 密码
            if (this.type != 5) {
                let psw = this.registForm.psw.trim();
                if (psw.length < 4 || psw.length > 18) {
                    this.registForm.pswErr = '请输入4-18位（数字，字母，下划线）的密码!';
                    return;
                }
            }

            this.loadingFlag = true;
            // 注册
            if (this.type == 2) {
                let fromWay = '';
                if (this.fromWay) {
                    fromWay = '&from_way=' + this.fromWay;
                }
                axios.post(base + 'kstk-api/userlogin/regist?ph=' + this.registForm.phone + '&pw=' + this.registForm.psw + '&code=' + this.registForm.msgCode + fromWay)
                    .then(res => {
                        this.loadingFlag = false;
                        if (res.code == 200) {
                            this.loginForm.phone = this.registForm.phone;
                            this.loginForm.psw = this.registForm.psw;
                            this.login();
                        } else {
                            this.registForm.formErr = res.msg;
                        }
                    })
                    .catch(err => console.log(err));
            }
            // 找回密码
            if (this.type == 3) {
                axios.post(base + 'kstk-api/userlogin/upPsd?ph=' + this.registForm.phone + '&npw=' + this.registForm.psw + '&code=' + this.registForm.msgCode)
                    .then(res => {
                        this.loadingFlag = false;
                        if (res.code == 200) {
                            this.successFlag = true;
                            setTimeout(() => {
                                location.href = base;
                            }, 1000 * 3);
                            setInterval(() => {
                                this.countDown--;
                            }, 1000);
                        } else {
                            this.registForm.formErr = res.msg;
                        }
                    })
                    .catch(err => console.log(err));
            }
            // 绑定手机号
            if (this.type == 5) {
                axios.post(base + 'kstk-api/userlogin/sacnbdPhone?ph=' + this.registForm.phone + '&code=' + this.registForm.msgCode)
                    .then(res => {
                        this.loadingFlag = false;
                        if (res.code == 200) {
                            this.loginForm.phone = this.registForm.phone;
                            this.$emit('login-success');
                        } else {
                            this.registForm.formErr = res.msg;
                        }
                    })
                    .catch(err => console.log(err));
            }
        }
    },
    created() {
        this.loginForm.phone = localStorage.phone || '';
        this.loginForm.psw = localStorage.psw || '';
        if (this.type == 1) {
            this.getQrcode()
        }
    }
});

/**
 *分页
 *@prop {number, string} currentPage 当前页数
 *@prop {number, string} totalPage 总页数
 */
Vue.component('pagination-group', {
    template:
        '<div class="pagination-wrap">\n' +
        '    <div class="pagination clearfix" :style="{width: totalPage < 6 ? 310 + (totalPage || 1 - 1) * 40 + \'px\' : \'470px\'}">\n' +
        '            <div class="pages fl clearfix">\n' +
        '                <div class="btn prev fl" title="上一页" :class="{disabled: page == 1}" @click="turn(-1)">\n' +
        '                    <span class="iconfont icon-shangyiye"></span>\n' +
        '                </div>\n' +
        '                <div class="btn number fl" v-if="totalPage - page < 1 && page > 4" @click="turn(-4)">{{page - 4}}</div>\n' +
        '                <div class="btn number fl" v-if="totalPage - page < 2 && page > 3" @click="turn(-3)">{{page - 3}}</div>\n' +
        '                <div class="btn number fl" v-if="totalPage - page < 3 && page > 2" @click="turn(-2)">{{page - 2}}</div>\n' +
        '                <div class="btn number fl" v-if="totalPage - page < 4 && page > 1" @click="turn(-1)">{{page - 1}}</div>\n' +
        '                <div class="btn number fl active">{{page}}</div>\n' +
        '                <div class="btn number fl" v-if="totalPage - page > 1" @click="turn(1)">{{page + 1}}</div>\n' +
        '                <div class="btn number fl" v-if="totalPage - page > 2" @click="turn(2)">{{page + 2}}</div>\n' +
        '                <div class="btn number fl" v-if="totalPage - page == 4" @click="turn(3)">{{page + 3}}</div>\n' +
        '                <div class="btn number disabled fl" v-if="totalPage - page > 4">...</div>\n' +
        '                <div class="btn number fl" v-if="page < totalPage" @click="turnLast">{{totalPage}}</div>\n' +
        '                <div class="btn next fl" title="下一页" :class="{disabled: page  == totalPage}" @click="turn(1)">\n' +
        '                    <span class="iconfont icon-xiayiye"></span>\n' +
        '                </div>\n' +
        '            </div>\n' +
        '            <div class="jump fl">\n' +
        '                <span class="text">跳至</span>\n' +
        '                <input type="number" v-model="turnPage" @input="checkTurnPage"  @keyup.enter="turnTo">\n' +
        '                <span class="text">页</span>\n' +
        '            </div>\n' +
        '            <div class="btn true fl" @click="turnTo">确定</div>\n' +
        '        </div>\n' +
        '    </div>',
    props: {
        currentPage: [Number, String],
        totalPage: [Number, String],
    },
    data() {
        return {
            page: this.currentPage,
            turnPage: ''
        }
    },
    watch: {
        currentPage: function(newVal) {
            this.page = newVal;
        }
    },
    methods: {
        turn(number) {
            if (this.page == 1 && number == -1) {
                return;
            }
            if (this.page == this.totalPage && number == 1) {
                return;
            }
            this.page += number;
            this.$emit('turn-page', this.page);
        },
        turnLast() {
            this.page = this.totalPage;
            this.$emit('turn-page', this.page);
        },
        turnTo() {
            if (!this.turnPage || this.turnPage == this.page) {
                return;
            }
            this.page = this.turnPage;
            this.turnPage = '';
            this.$emit('turn-page', this.page);
        },
        checkTurnPage() {
            this.turnPage = parseInt(this.turnPage);
            if (this.turnPage < 1) {
                this.turnPage = 1;
            }
            if (this.turnPage > this.totalPage) {
                this.turnPage = this.totalPage;
            }
        },
    }
});

/**
 *个人中心导航
 *@prop {object} user 用户信息
 *@prop {array} majorList 用户开课列表
 *@prop {number, string} activeIndex 需要激活点导航索引
 *@prop {number, string} mid 专业id
 */
Vue.component('user-nav', {
    template:
        '        <div class="user-nav fl" :class="{fixed: true}">\n' +
        '            <div class="photo-wrap">\n' +
        '                <img :src="user.logo || \'images/photo-default.png?2102231609\'" alt="">\n' +
        '            </div>\n' +
        '            <span class="icon icon-vip-user"></span>\n' +
        '            <div class="name" :title="user.nickname ? user.nickname : user.phone">{{user.nickname ? user.nickname : user.phone}}</div>\n' +
        '            <p class="date">专题课程有效期至<br>{{user.end_time}}</p>\n' +
        '            <ul class="nav-list">\n' +
        '                <a href="pages/user/class.html">\n' +
        '                    <li class="nav-item" :class="{active: activeIndex == 0}">\n' +
        '                        <span class="icon icon-wdkc"></span>\n' +
        '                        <span class="title">我的课程</span>\n' +
        '                    </li>\n' +
        '                </a>\n' +
        '                <a href="pages/user/live.html">\n' +
        '                    <li class="nav-item" :class="{active: activeIndex == 1}">\n' +
        '                        <span class="icon icon-zbyg"></span>\n' +
        '                        <span class="title">近期直播</span>\n' +
        '                    </li>\n' +
        '                </a>\n' +
        '                <a href="pages/user/data.html">\n' +
        '                    <li class="nav-item" :class="{active: activeIndex == 2}">\n' +
        '                        <span class="icon icon-xxzl"></span>\n' +
        '                        <span class="title">学习资料</span>\n' +
        '                    </li>\n' +
        '                </a>\n' +
        '                <a href="pages/user/test.html">\n' +
        '                    <li class="nav-item" :class="{active: activeIndex == 3}">\n' +
        '                        <span class="icon icon-xxtk"></span>\n' +
        '                        <span class="title">学习题库</span>\n' +
        '                    </li>\n' +
        '                </a>\n' +
        '                <a href="pages/user/analysis.html">\n' +
        '                    <li class="nav-item" :class="{active: activeIndex == 7}">\n' +
        '                        <span class="icon icon-xxtk"></span>\n' +
        '                        <span class="title">学习数据</span>\n' +
        '                    </li>\n' +
        '                </a>\n' +
        '                <a href="pages/user/questions.html">\n' +
        '                    <li class="nav-item" :class="{active: activeIndex == 4}">\n' +
        '                        <span class="icon icon-dyzx"></span>\n' +
        '                        <span class="title">答疑中心</span>\n' +
        '                    </li>\n' +
        '                </a>\n' +
        '                <a href="pages/user/info.html">\n' +
        '                    <li class="nav-item" :class="{active: activeIndex == 6}">\n' +
        '                        <span class="icon icon-grzx"></span>\n' +
        '                        <span class="title">个人中心</span>\n' +
        '                    </li>\n' +
        '                </a>\n' +
        '            </ul>\n' +
        '        </div>',
    props: {
        activeIndex: [Number, String],
        user: {
            type: Object,
            default: {}
        },
        majorList: Array
    },
    data() {
        return {
            carCount: 0,
            mid: null,
            list: this.majorList,
            fixedFlag: false
        }
    },
    watch: {
        user: function (newVal) {
            this.mid = newVal.last_major_id;
        }
    },
    mounted: function () {
        // window.addEventListener('scroll', () => {
        //     const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        //     this.fixedFlag = scrollTop > 84;
        // });
    }
});

/**
 *表单提交成功
 *@prop {string} text 提示文字
 */
Vue.component('form-success', {
    template:
        '<div class="form-success">\n' +
        '    <div class="img"></div>\n' +
        '    <p class="text">{{text}}</p>\n' +
        '</div>',
    props: {
        text: String
    }
});

/**
 *未购买课程提示
 *@prop {string} text 提示文字
 */
Vue.component('class-empty', {
    template:
        '<div class="class-empty">\n' +
        '    <div class="img"></div>\n' +
        '    <p class="text">{{text}}</p>\n' +
        '</div>',
    props: {
        text: {
            type: String,
            default: '您还没有购买课程哦！'
        }
    }
});

/**
 *返回顶部
 */
Vue.component('back-top', {
    template:
        '<div class="back-top" title="返回顶部" @click="scrollTo(0)">\n' +
        '    <span class="iconfont icon-shouqi"></span>\n' +
        '</div>',
});

/**
 *空列表提示
 *@prop {string} text 提示文字
 */
Vue.component('list-empty', {
    template: '<div class="list-empty">{{text}}</div>',
    props: {
        text: {
            type: String,
            default: '暂无内容！'
        }
    }
});

/**
 *AAA头部
 *@prop {number, string} activeIndex 需要激活点导航索引
 *@prop {number, string} mid 专业id
 */
Vue.component('aaa-header', {
    template:
        '<div class="page-header aaa-header">\n' +
        '        <div class="container clearfix">\n' +
        '            <div class="logo fl">\n' +
        '                <a href="aaa/index.html">\n' +
        '                	<img src="images/header-logo-aaa.png" alt="">\n' +
        '                </a>\n' +
        '            </div>\n' +
        '            <ul class="nav fl clearfix">\n' +
        '                <li class="nav-item fl" v-for="(item, index) in navList" :key="index" :class="{active: index == activeIndex}" @click="changeNav(item)">{{item.text}}</li>\n' +
        '            </ul>\n' +
        '            <div class="btns-wrap fr" v-if="loginFlag === false">\n' +
        '                <span class="text-btn" @click="goLogin(1)">登录</span>\n' +
        '                <span class="division">|</span>\n' +
        '                <span class="text-btn" @click="goLogin(2)">注册</span>\n' +
        '            </div>\n' +
        '            <div class="info" v-if="loginFlag">\n' +
        '                <div class="user clearfix">\n' +
        '                    <a :href="\'pages/user/class.html?mid=\' + mid">\n' +
        '                    	<div class="photo-wrap fl">\n' +
        '                        	<img :src="user.logo || \'images/photo-default.png?2102231609\'" alt="">\n' +
        '                    	</div>\n' +
        '                    	<div class="name fl" :title="user.nickname ? user.nickname : user.phone">{{user.nickname ? user.nickname : user.phone}}</div>\n' +
        '                    	<span class="dot" v-if="carCount"></span>\n' +
        '                    </a>\n' +
        '                    <span class="iconfont icon-xia"></span>\n' +
        '                </div>\n' +
        '                <ul class="list">\n' +
        '                    <a href="pages/user/cart.html">\n' +
        '                        <li class="item">购物车<span class="badge" v-if="carCount">{{carCount}}</span></li>\n' +
        '                    </a>\n' +
        '                    <a href="pages/user/info.html">\n' +
        '                        <li class="item">个人资料</li>\n' +
        '                    </a>\n' +
        '                    <li class="item" @click="logout">退出登录</li>\n' +
        '                </ul>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>',
    props: {
        activeIndex: [Number, String],
        mid: {
            type: [Number, String],
            default: 11
        }
    },
    data() {
        return {
            loginFlag: null,
            navList: [
                {
                    text: '关于信用',
                    link: 'aaa/index.html'
                },
                {
                    text: '在线评测',
                    link: 'aaa/form.html'
                },
                {
                    text: '信用政策',
                    link: 'aaa/list.html'
                },
            ],
            carCount: 0,
            user: {}
        }
    },
    methods: {
        changeNav(nav) {
            window.open(nav.link)
        },
        logout() {
            axios.post(baseURL + 'loginout')
                .then(res => {
                    if (res.code == 200) {
                        localStorage.psw = '';
                        location.reload();
                    }
                })
                .catch(err => console.log(err));
        },
    },
    created() {
        this.checkLogin(user => {
            if (user) {
                this.loginFlag = true;
                this.carCount = user.carCount;
                this.user = user.user;
            } else {
                this.loginFlag = false;
            }
            this.$emit('header-login', this.user);
        });
    }
});

/**
 *AAA页脚
 */
Vue.component('aaa-footer', {
    template:
        '<div class="page-footer aaa-footer">\n' +
        '    <div class="container clearfix">\n' +
        '        <div class="img-wrap img1 fl">\n' +
        '            <img src="images/aaa1.png" alt="">\n' +
        '        </div>\n' +
        '        <div class="img-wrap img2 fl">\n' +
        '            <img src="images/aaa4.png" alt="">\n' +
        '        </div>\n' +
        '        <div class="text-wrap fl">\n' +
        '            <h4 class="title">中国工业合作协会</h4>\n' +
        '            <p class="content">\n' +
        '                地址： 北京市东城区建国门内大街金城成国5号1702<br>\n' +
        '                联系人： 张老师 13011148912\n<br>\n' +
        '            </p>\n' +
        '            <h4 class="title">承办机构</h4>\n' +
        '            <p class="content">\n' +
        '                中科建安（北京）安全技术服务有限公司<br>\n' +
        '                总部地址： 北京市昌平区石坊院21号12层1207\n' +
        '            </p>\n' +
        '        </div>\n' +
        '        <div class="qr-wrap fl">\n' +
        '            <p class="text">立即咨询</p>\n' +
        '            <div class="img-wrap qr">\n' +
        '                <img src="images/qrcode-aaa.png" alt="">\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '    <div class="copyright">版权所有&nbsp;©2006-2023&nbsp;中科建安&nbsp;All&nbsp;Rights&nbsp;Reserved&nbsp;&nbsp;&nbsp;&nbsp;京ICP备2022020722</div>\n' +
        '</div>',
});

/**
 *经理人头部
 *@prop {number, string} activeIndex 需要激活点导航索引
 */
Vue.component('manager-header', {
    template:
        '<div class="page-header manager-header">\n' +
        '        <div class="container clearfix" style="width: 1340px">\n' +
        '            <div class="logo fl">\n' +
        '                <a href="manager/index.html">\n' +
        '                	<img src="images/header-logo-manager.png" alt="">\n' +
        '                </a>\n' +
        '            </div>\n' +
        '            <ul class="nav fl clearfix">\n' +
        '                <li class="nav-item fl" v-for="(item, index) in navList" :key="index" :class="{active: index == activeIndex}" @click="changeNav(item)">{{item.text}}</li>\n' +
        '            </ul>\n' +
        '            <div class="btns-wrap fr" v-if="loginFlag === false">\n' +
        '                <span class="text-btn" @click="goLogin(1)">登录</span>\n' +
        '                <span class="division">|</span>\n' +
        '                <span class="text-btn" @click="goLogin(2)">注册</span>\n' +
        '            </div>\n' +
        '            <div class="info" v-if="loginFlag">\n' +
        '                <div class="user clearfix">\n' +
        '                    <a :href="\'pages/user/class.html?mid=\' + mid">\n' +
        '                    	<div class="photo-wrap fl">\n' +
        '                        	<img :src="user.logo || \'images/photo-default.png?2102231609\'" alt="">\n' +
        '                    	</div>\n' +
        '                    	<div class="name fl" :title="user.nickname ? user.nickname : user.phone">{{user.nickname ? user.nickname : user.phone}}</div>\n' +
        '                    	<span class="dot" v-if="carCount"></span>\n' +
        '                    </a>\n' +
        '                    <span class="iconfont icon-xia"></span>\n' +
        '                </div>\n' +
        '                <ul class="list">\n' +
        '                    <a href="pages/user/cart.html">\n' +
        '                        <li class="item">购物车<span class="badge" v-if="carCount">{{carCount}}</span></li>\n' +
        '                    </a>\n' +
        '                    <a href="pages/user/info.html">\n' +
        '                        <li class="item">个人资料</li>\n' +
        '                    </a>\n' +
        '                    <li class="item" @click="logout">退出登录</li>\n' +
        '                </ul>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>',
    props: {
        activeIndex: [Number, String],
        mid: {
            type: [Number, String],
            default: 11
        }
    },
    data() {
        return {
            loginFlag: null,
            navList: [
                {
                    text: '首页',
                    link: 'manager/index.html'
                },
                {
                    text: '新闻动态',
                    link: 'manager/list.html?type=14'
                },
                {
                    text: '政策文件',
                    link: 'manager/list.html?type=16'
                },
                {
                    text: '证书样本',
                    link: 'manager/sample.html'
                },
                {
                    text: '在线申报',
                    link: 'manager/form.html'
                },
                {
                    text: '考培大纲',
                    link: 'manager/test.html'
                },
                {
                    text: '网络教育',
                    link: 'manager/edu.html'
                },
                {
                    text: '联系我们',
                    link: 'manager/concat.html'
                },
            ],
            carCount: 0,
            user: {}
        }
    },
    methods: {
        changeNav(nav) {
            window.open(nav.link)
        },
        logout() {
            axios.post(baseURL + 'loginout')
                .then(res => {
                    if (res.code == 200) {
                        localStorage.psw = '';
                        location.reload();
                    }
                })
                .catch(err => console.log(err));
        },
    },
    created() {
        this.checkLogin(user => {
            if (user) {
                this.loginFlag = true;
                this.carCount = user.carCount;
                this.user = user.user;
            } else {
                this.loginFlag = false;
            }
            this.$emit('header-login', this.user);
        });
    }
});

/**
 *经理人页脚
 */
Vue.component('manager-footer', {
    template:
        '<div class="page-footer manager-footer">\n' +
        '    <div class="container clearfix">\n' +
        '        <div class="img-wrap img1 fl">\n' +
        '            <img src="images/manager1.png" alt="">\n' +
        '        </div>\n' +
        '        <div class="img-wrap img2 fl">\n' +
        '            <img src="images/manager2.png" alt="">\n' +
        '        </div>\n' +
        '        <div class="img-wrap img3 fl">\n' +
        '            <img src="images/manager3.png" alt="">\n' +
        '        </div>\n' +
        '        <div class="text-wrap fl">\n' +
        '            <h4 class="title">联系我们</h4>\n' +
        '            <p class="content">\n' +
        '                座机电话： 010-61705052  61705426<br>\n' +
        '                联系人： 张老师 13011148912\n<br>\n' +
        '            </p>\n' +
        '            <p class="content">\n' +
        '                中国企业联合会 · 中国企业家协会<br>\n' +
        '                地址： 北京市海淀区紫竹院南路17号\n' +
        '            </p>\n' +
        '        </div>\n' +
        '        <div class="qr-wrap fl">\n' +
        '            <p class="text">立即咨询</p>\n' +
        '            <div class="img-wrap qr">\n' +
        '                <img src="images/qrcode-manager.png" alt="">\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '    <div class="copyright">版权所有&nbsp;©2006-2023&nbsp;中科建安&nbsp;All&nbsp;Rights&nbsp;Reserved&nbsp;&nbsp;&nbsp;&nbsp;京ICP备2022020722</div>\n' +
        '</div>',
});
